(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wyze-image-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const images = document.querySelectorAll('.mw-image-gallery a');
    const modal = document.querySelector('.mw-modal');
    const modalImage = modal.querySelector('img');
    let currentIndex = 0;
    let initialScrollPosition = 0; // Add a variable to store the initial scroll position - Mod V

    // Open modal popup and show clicked image
    function showModal(index) {
      if (window.innerWidth > 749) {
        modalImage.src = images[index].dataset.desktop;
      } else {
        modalImage.src = images[index].dataset.mobile;
      }
      modal.classList.add('show');
      currentIndex = index;
      initialScrollPosition = window.scrollY; // Store the initial scroll position - Mod V
    }

    // Hide modal popup
    function hideModal() {
      modal.classList.remove('show');
      // Restore the initial scroll position - Mod V
      window.scrollTo(0, initialScrollPosition);
    }

    // Show previous image in gallery
    function showPrevImage(e) {
      e.stopPropagation();
      if (currentIndex === 0) {
        showModal(images.length - 1);
      } else {
        showModal(currentIndex - 1);
      }
    }

    // Show next image in gallery
    function showNextImage(e) {
      e.stopPropagation();
      if (currentIndex === images.length - 1) {
        showModal(0);
      } else {
        showModal(currentIndex + 1);
      }
    }

    // Add click event listeners to all images
    images.forEach((image, index) => {
      image.addEventListener('click', (e) => {
        e.preventDefault();
        showModal(index);
      });
    });

    // Add click event listeners to modal navigation arrows
    const prevArrow = modal.querySelector('.mw-modal-prev');
    prevArrow.addEventListener('click', showPrevImage);

    const nextArrow = modal.querySelector('.mw-modal-next');
    nextArrow.addEventListener('click', showNextImage);

    // Add click event listener to modal background to hide it
    modal.addEventListener('click', hideModal);

    // Add click event listener to the close button with the class "mw-modal-close"
    const modalCloseButton = modal.querySelector('.mw-modal-close');
    modalCloseButton.addEventListener('click', hideModal);
  })();

  } catch(e) { console.error(e); }
})();
})();
